var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1EA548;}\n\t.st1{fill:#2B4250;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113,32.3c1.1,2.5,4,3.7,6.5,2.6c2.5-1.1,3.7-4,2.6-6.5l-8.9-20.8c-1.1-2.5-4-3.7-6.5-2.6 c-2.5,1.1-3.7,4-2.6,6.5L113,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150,35.3c2.7,0,5-2.2,5-5V9.5c0-2.7-2.2-5-5-5s-5,2.2-5,5v20.8C145.1,33,147.3,35.3,150,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.5,34.9c2.5,1.1,5.4,0,6.5-2.6l8.9-20.8c1.1-2.5-0.1-5.4-2.6-6.5c-2.5-1.1-5.4,0.1-6.5,2.6l-8.9,20.8 C176.8,30.9,178,33.8,180.5,34.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.2,114c-0.2,0.4-0.6,0.6-1,0.6h-78.1c-0.5,0-1-0.3-1.1-0.8c-0.2-0.5-0.1-1,0.3-1.4l55-47.8 c0.2-0.2,0.6-0.3,1-0.3c0.4,0.1,0.7,0.3,0.9,0.7l23.1,47.8C287.5,113.2,287.5,113.6,287.2,114z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.8,63.2c-0.3-0.4-0.3-0.9-0.1-1.3c0.2-0.4,0.6-0.7,1.1-0.7h91.7c0.5,0,1,0.3,1.1,0.8 c0.2,0.5,0.1,1-0.3,1.4L196.5,112c-0.2,0.2-0.5,0.3-0.8,0.3h-0.1c-0.3-0.1-0.6-0.2-0.8-0.5L158.8,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9,123.6l-38.7,170.9c-0.1,0.5-0.6,0.9-1.2,0.9s-1.1-0.4-1.2-1l-38.6-170.9c-0.1-0.3,0-0.7,0.2-1 c0.2-0.3,0.6-0.4,1-0.4h77.3c0.4,0,0.7,0.2,1,0.4C189.9,122.8,190,123.2,189.9,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.5,122.7c0.2,0.4,0.2,0.9-0.1,1.3L161.1,295c-0.3,0.3-0.6,0.5-1,0.5c-0.2,0-0.3,0-0.5-0.1 c-0.5-0.2-0.8-0.8-0.7-1.4L197.6,123c0.1-0.5,0.6-0.9,1.2-0.9h85.5C284.8,122,285.3,122.3,285.5,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114,112.6l35-47.5c0.4-0.6,1.5-0.6,2,0l35.1,47.5c0.3,0.4,0.3,0.9,0.1,1.3c-0.2,0.4-0.6,0.7-1.1,0.7H115 c-0.4,0-0.9-0.2-1.1-0.7C113.6,113.5,113.7,113,114,112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.4,123L141,293.9c0.2,0.5-0.1,1.1-0.7,1.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0-0.7-0.2-1-0.5L14.6,124 c-0.3-0.4-0.3-0.9-0.1-1.3c0.2-0.4,0.6-0.7,1.1-0.7h85.6C101.8,122,102.3,122.4,102.4,123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.7,63.4c-0.4-0.3-0.5-0.9-0.3-1.4c0.2-0.5,0.6-0.8,1.1-0.8h91.7c0.4,0,0.9,0.2,1.1,0.7 c0.2,0.4,0.2,0.9-0.1,1.3l-35.8,48.6c-0.2,0.3-0.5,0.4-0.8,0.5h-0.2c-0.3,0-0.6-0.1-0.8-0.3L47.7,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,114.6H13.8c-0.4,0-0.8-0.2-1-0.6c-0.2-0.3-0.2-0.8,0-1.2l23.1-47.8c0.2-0.3,0.5-0.6,0.9-0.7 c0.4-0.1,0.8,0,1,0.3l55,47.8c0.4,0.3,0.5,0.9,0.3,1.4C92.9,114.3,92.4,114.6,91.9,114.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.68059979caeaface3a1ec2db3c5e3e4d.svg";
export { ForwardRef as ReactComponent };